// DL Fork: shared postMessage origin matcher (uplift C0).
//
// This is the FRONTEND-USABLE copy of the allowlist matcher. The BI bridge
// (fork frontend) re-validates the captured `targetOrigin` against the
// non-secret `embedding.postMessage` allowlist exposed on the health endpoint
// before activating the postMessage channel — fail-closed if it does not match.
//
// DRIFT PIN: the backend has an INDEPENDENT copy at
// `packages/backend/src/ee/utils/postMessageAllowlist.ts`
// (`isAllowedPostMessageOrigin`) used by the dl-auth bridge success redirect.
// The two implementations MUST stay behaviourally identical — any change to the
// matching semantics here must be mirrored there (and vice-versa), and both
// test suites re-run. The backend file is deliberately NOT deleted/re-pointed:
// scp-based deploys cannot ship file deletions, so this is an ADDITIVE copy.
//
// Contract (identical to the backend copy):
//   - `raw` is whatever the caller supplied. If it does not parse as a URL the
//     function returns `false`.
//   - `cfg.exactOrigins` is an array of NORMALISED origins (lowercased,
//     default-port collapsed). Exact match preserves the configured protocol
//     (e.g. `http://localhost:5173` is allowed for dev).
//   - `cfg.suffixes` is an array of validated, lowercased leading-dot suffixes
//     such as `.app.example-bi.com`. Suffix match is applied to the parsed
//     `URL.hostname` ONLY (never the raw string), so
//     `evil.app.example-bi.com.attacker.com` is rejected.
//   - Suffix matches additionally require `https:` — `http://` is only allowed
//     via the exact-origin branch (intended for localhost dev).
export function isAllowedPostMessageOrigin(raw, cfg) {
    if (!raw || typeof raw !== 'string')
        return false;
    let url;
    try {
        url = new URL(raw);
    }
    catch {
        return false;
    }
    const origin = url.origin.toLowerCase();
    const hostname = url.hostname.toLowerCase();
    // Exact-origin match: protocol + host + (non-default) port. Covers apex
    // (`https://app.example-bi.com`) and localhost dev.
    if (cfg.exactOrigins.includes(origin))
        return true;
    // Suffix match MUST enforce https. Exact-list entries may use http for
    // localhost; suffix match never relaxes transport security.
    if (url.protocol !== 'https:')
        return false;
    // Suffix match on HOSTNAME ONLY (never the raw string). Each suffix starts
    // with '.' so `.app.example-bi.com` matches `sub.app.example-bi.com` but NOT
    // `evil.app.example-bi.com.attacker.com` (hostname ends `.attacker.com`).
    return cfg.suffixes.some((sfx) => hostname.endsWith(sfx));
}
//# sourceMappingURL=postMessageOrigin.js.map